<template>
  <div class="trade_layer" v-show="isShow">
    <div class="hd">
      <h3 class="tit">{{ tradeTypeText }} 등록하기</h3>
      <a class="btn_close" href="javascript:;" v-on:click="closePopup"></a>
    </div>
    <div class="bd">
      <dl class="row">
        <dt>등록내역</dt>
        <dd>
          <input type="text" name="t_type" class="readonly" :value="tradeTypeText" readonly="readonly" />
        </dd>
      </dl>
      <dl class="row">
        <dt>{{ registTradeTypeText }} 아이템</dt>
        <dd class="item_list">
          <select v-model="userItemId" class="select">
            <option value="" disabled="disabled" selected="selected">아이템을 선택해 주세요.</option>
            <option :value="value.id" v-for="(value, index) in myItems" :key="index">
              {{ value.name }} ({{ value.stampAmount }} / {{ value.maxAmount }})
            </option>
          </select>
        </dd>
      </dl>
      <dl class="row">
        <dt>희망골드</dt>
        <dd>
          <input type="number" v-model="amount" class="gold" placeholder="0" required="required" maxlength="8" />
        </dd>
      </dl>
      <div class="btn_area">
        <button type="button" class="btn btn_exec" v-on:click="registItem">등록하기</button>
        <button type="button" class="btn btn_cancel" v-on:click="closePopup">취소하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import common from '../../mixins/common';

  export default {
    name: 'trade-regist',
    mixins: [
      common
    ],
    data() {
      return {
        isShow: false,
        myItems: [],
        amount: null,
        userItemId: ''
      }
    },
    created() {
      this.$eventBus.$on("openPopup", this.isOpenPopup);
    },
    methods: {
      isOpenPopup() {
        this.getMyItem();

        $("._layer_background").click( () => {
          $('._layer_background').hide();
          this.closePopup();
        })
      },
      async getMyItem() {
        let res = await this._get("/v1/trade/myItems", {
          tradeType: this.tradeType
        });

        if (res.data.length <= 0) {
          alert('판매 가능한 아이템이 없습니다');
          $('._layer_background').hide();
          return false;
        }
        this.myItems = res.data;
        this.isShow = true;
      },
      async registItem() {

        if (!this.userItemId) {
          alert('아이템을 선택해주세요.');
          return false;
        }

        if (this.amount < 1000) {
          alert('판매 최소금액은 1,000 (GOLD) 입니다.');
          return false;
        }

        if (this.amount > 10000000) {
          alert('최대 판매금액은 10,000,000(GOLD) 입니다.');
          return false;
        }

        let res = await this._post("/v1/trade", {
          tradeType: this.tradeType,
          userItemId: this.userItemId,
          amount: this.amount
        });

        this.isShow = false;
        this.$eventBus.$emit("changeLIstItem");
        alert(res.data.message);
        $('._layer_background').hide();
      }
    },
    computed: {
      registTradeTypeText: function () {
        return this.tradeType === 'SELL' ? '보유' : '희망'
      },
    },
    watch: {
      amount: function (to, from) {
        if (to.length > 10){
          this.amount =  to.slice(0, 10);
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/store/trade-regist.vue